import React, { useState, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import config from '../../../../config/config';
import { requestAgentTransaction } from '../../../../store/actionCreators/grantCredit';
import { getClubChipBalance, getClubList } from '../../../../store/selectors';
import '../../../../assets/stylesheets/Dialogs/TransferDialog.sass';
import BalanceField from '../../Counter/components/BalanceField';

const re = /[0-9\.,]/g;
const sendOut = 'sendOut';
const claimBack = 'claimBack';

const TransferDialog = ({type, agent, onClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id: clubId } = useParams();

  const clubBalance = useSelector(getClubChipBalance);
  const agentBalance = agent.roleAccountWallets[0].balance;
  const balance = type === sendOut ? clubBalance : agentBalance;
  const clubList = useSelector(getClubList);
  const club = useMemo(() => clubList.find(c => c.clubId.toString() === clubId), [clubList, clubId]);
  
  const [amount, setAmount] = useState(null);

  const onChange = useCallback((e) => {
    let number = parseFloat(e.target.value);
    if (number > balance) number = balance;
    else if (number < 0) number = 0;
    setAmount(number);
  }, [balance, amount]);

  const onConfirm = useCallback(() => {
    const from = type === sendOut ? clubId : agent.roleAccountId;
    const to = type === sendOut ? agent.roleAccountId : clubId;
    let number = amount;
    if (number <= balance && number >= 0) {
      dispatch(requestAgentTransaction(from, to, amount, agent.roleAccountId));
      if (onClose) onClose();
    }
  }, [type, clubId, agent, balance, amount]);

  return (
    <div className="grant-credit-popup">
      <div className="grant-credit-popup__background" onClick={onClose} />
      <div className="grant-credit-popup__body">
        <header className="grant-credit-popup__header">
          <span className="grant-credit-popup__header-text">
            {type === sendOut ? t('button.sendOut') : t('button.claimBack')}
          </span>
          <i className="grant-credit-popup__icon fa fa-times" onClick={onClose} />
        </header>
        <div className="grant-credit-popup__data">
          <div className="grant-credit-popup__names">
            <div className="grant-credit-popup__name">
              {type === sendOut ? club.clubName : (agent.nickname || agent.username)}
            </div>
            <div className="grant-credit-popup__name">
              {type === sendOut ? (agent.nickname || agent.username) : club.clubName}
            </div>
          </div>
          <div className="grant-credit-popup__balance">
            <div className="grant-credit-popup__balance-list">
              <div className="grant-credit-popup__balance-item">
                <BalanceField 
                  role='chip'
                  amount={type === sendOut ? clubBalance : agentBalance}
                />
                
              </div>
              <div className="grant-credit-popup__balance-item">
                <BalanceField 
                  role='chip'
                  amount={type === sendOut ? agentBalance : clubBalance}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="grant-credit-popup__form">
          <input
            className="grant-credit-popup__input"
            min="0"
            max={balance}
            step="1"
            type="number"
            value={amount}
            placeholder={t('dialog.enterAmount')}
            onChange={onChange}
            autoFocus={true}
          />
          <button className="grant-credit-popup__submit" onClick={onConfirm}>
            {t('button.confirm')}
          </button>
        </div>
      </div>
    </div>

  )

}

export default TransferDialog;